<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <v-flex xs12>
    <v-card elevation="15">
      <v-card-title primary-title class="h3">
        MiniDeb-spärr
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-container>
            <v-row class="align-center">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model.number="entry.customerNr"
                  label="Kundnummer"
                  type="number"
                  clearable
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="entry.paper"
                  :items="paperOptions"
                  item-text="label"
                  item-value="value"
                  label="Spärrad tidning"
                />
              </v-col>
              <v-col cols="2" sm="2" md="1" class="center">
                <v-btn small icon @click.stop="save()">
                  <v-icon>save</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          sort-by="customerNr"
          must-sort
          @click:row="edit"
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Spärrade kunder</v-toolbar-title>
              <v-spacer />
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Sök kundnummer"
                single-line
                hide-details
                clearable
                style="max-width: 220px"
              />
            </v-toolbar>
          </template>
          <template #[`item.paper`]="{ item }">
            {{ paperLabel(item.paper) }}
          </template>
          <template #[`item.timestamp`]="{ item }">
            {{ item.timestamp | toLocalDate }}
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn x-small icon @click.stop="remove(item)">
              <v-icon color="primary">
                delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import api from '@/backend/adminapi'
import log from '@/logger'

const PAPER_OPTIONS = [
  { value: 0, label: 'Båda (Aftonbladet & Expressen)' },
  { value: 1, label: 'Aftonbladet' },
  { value: 2, label: 'Expressen' },
]

const emptyEntry = () => ({ customerNr: null, paper: 0 })

export default {
  name: 'MiniDeb',
  data() {
    return {
      items: [],
      entry: emptyEntry(),
      paperOptions: PAPER_OPTIONS,
      search: '',
      headers: [
        { text: 'Kundnummer', value: 'customerNr' },
        { text: 'Spärrad tidning', value: 'paper' },
        { text: 'Uppdaterad', value: 'timestamp', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' },
      ],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const resp = await api.adminGetMiniDeb()
        this.items = resp.data
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          this.$router.push({ name: 'root' })
        }
        log.error('Error loading MiniDeb:', error)
      }
    },
    edit(item) {
      this.entry = { customerNr: item.customerNr, paper: item.paper }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async save() {
      if (!this.entry.customerNr) return
      try {
        await api.adminSaveMiniDeb(this.entry)
        this.entry = emptyEntry()
        await this.loadData()
      } catch (error) {
        log.error('Error saving MiniDeb:', error)
      }
    },
    async remove(item) {
      try {
        await api.adminDeleteMiniDeb(item.customerNr)
        await this.loadData()
      } catch (error) {
        log.error('Error deleting MiniDeb:', error)
      }
    },
    paperLabel(paper) {
      const opt = PAPER_OPTIONS.find(p => p.value === paper)
      return opt ? opt.label : paper
    },
  },
}
</script>
